import { render, staticRenderFns } from "./UpdateSnackbar.vue?vue&type=template&id=aedf988e&scoped=true"
import script from "./UpdateSnackbar.vue?vue&type=script&lang=js"
export * from "./UpdateSnackbar.vue?vue&type=script&lang=js"
import style0 from "./UpdateSnackbar.vue?vue&type=style&index=0&id=aedf988e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aedf988e",
  null
  
)

export default component.exports